/**
 * API `invalid_fields` key → `DivisionFormState` key, plus friendly titles.
 *
 * The payload and the form disagree on names in three places, which is the whole
 * reason this map exists:
 *
 * - the API calls the name/type `name` / `type`, the form calls them
 *   `name` / `type` but the PAYLOAD calls them `title` / `subtitle`
 * - the Salesforce ID is `import_2_id` on write and `salesforce_id` on read, so
 *   BOTH must land on the single `salesforceId` input
 * - everything else is snake_case → camelCase
 *
 * Keys with no form input (`season_type`, `season_currency`, `tax_rate`) are
 * deliberately absent: they are round-tripped from the node, not editable, so an
 * error on them has nothing to highlight and should fall through to the toast.
 */
export const DIVISION_API_FIELD_MAP: Record<string, string> = {
  name: 'name',
  name_full: 'name',
  type: 'type',
  sort_order: 'sortOrder',
  is_visible_standings: 'isVisibleStandings',
  lock_roster_date: 'lockRosterDate',
  // Both directions of the Salesforce ID asymmetry point at the one input.
  import_2_id: 'salesforceId',
  salesforce_id: 'salesforceId',
  division_group: 'divisionGroup',
  division_age: 'divisionAge',
  division_gender: 'divisionGender',
  day_of_week: 'dayOfWeek',
  deposit: 'deposit',
  team_cost: 'teamCost',
  is_active: 'isActive',
  online_registration_open: 'onlineRegistrationOpen',
}

/** Labels as the form renders them, so a toast names what the user sees. */
export const DIVISION_API_TITLE_MAP: Record<string, string> = {
  name: 'Name',
  name_full: 'Name',
  type: 'Type',
  sort_order: 'Sort Order',
  is_visible_standings: 'Show Division in Standings',
  lock_roster_date: 'Roster Lock Date',
  import_2_id: 'Salesforce ID',
  salesforce_id: 'Salesforce ID',
  division_group: 'Division Group',
  division_age: 'Division Age',
  division_gender: 'Division Gender',
  day_of_week: 'Day of Week',
  deposit: 'Deposit ($)',
  team_cost: 'Team Cost ($)',
  is_active: 'Is Active?',
  online_registration_open: 'Online Registration Open?',
}
